// productUsageService.js
import apiClient from '../utils/apiClient';

const BASE = '/v2/usage/admin';

const buildParams = ({ month, excludeAdmins = true } = {}) => {
  const params = new URLSearchParams();
  if (month) params.append('month', month);
  params.append('excludeAdmins', excludeAdmins ? '1' : '0');
  return params;
};

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const productUsageService = {
  getSummary: (options) => apiClient.get(`${BASE}/summary?${buildParams(options)}`),

  downloadSummary: async (options) => {
    const blob = await apiClient.get(`${BASE}/summary.csv?${buildParams(options)}`, {
      responseType: 'blob',
    });
    downloadBlob(blob, `product_usage_${options?.month || 'latest'}.csv`);
  },

  getDataUploads: ({ excludeAdmins = true } = {}) => {
    const params = new URLSearchParams();
    params.append('excludeAdmins', excludeAdmins ? '1' : '0');
    return apiClient.get(`${BASE}/data-uploads?${params}`);
  },

  downloadDataUploads: async ({ excludeAdmins = true } = {}) => {
    const params = new URLSearchParams();
    params.append('excludeAdmins', excludeAdmins ? '1' : '0');
    const blob = await apiClient.get(`${BASE}/data-uploads.csv?${params}`, {
      responseType: 'blob',
    });
    downloadBlob(blob, 'data_uploads.csv');
  },
};

export { productUsageService };
export default productUsageService;
